import hdrm from '../../hdrm';

export default (...args) => hdrm.instance.driver.referenceMap.getReferenceId(...args);
